import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import packageJson from '../../package.json';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { Subject, takeUntil } from 'rxjs';
import { SocialAuthService, SocialUser } from '@abacritt/angularx-social-login';
import { UserService } from './user/user.service';
import { FUNCTION, FunctionService } from './model-services/function.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { loadLicense } from './app.yfiles.license';
import { MAT_NATIVE_DATE_FORMATS, MatDateFormats } from '@angular/material/core';

export const GRI_DATE_FORMATS: MatDateFormats = {
    ...MAT_NATIVE_DATE_FORMATS,
    display: {
      ...MAT_NATIVE_DATE_FORMATS.display,
      dateInput: {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      } as Intl.DateTimeFormatOptions,
    }
};

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
    public static help:boolean = false

    private destroy$ = new Subject<void>();

    public version: string = packageJson.version;
    title = 'Linq v2';
    private readonly _destroying$ = new Subject<void>();

    help = AppComponent.help
    onboardingWidth=700
    initialStep:number = 1
    smallScreen:boolean = false
    mediumScreen:boolean = false
    largeScreen:boolean = false

    constructor(private router:Router, private msalService: MsalService, private authService: SocialAuthService, private msalBroadcastService: MsalBroadcastService, 
        public userService:UserService, private functionService:FunctionService, private breakpointObserver: BreakpointObserver, private cdRef: ChangeDetectorRef) {}

    ngOnInit(): void {
        loadLicense()
        
        //this.msalService.handleRedirectObservable().subscribe(() => console.log("Redirect event"));
        this.msalService.initialize()

        // microsoft state change
        this.msalBroadcastService.msalSubject$.pipe(takeUntil(this.destroy$)).subscribe({
            next: (msalSubject) => {
               if (msalSubject.eventType === 'msal:loginSuccess') {
                    const accounts = this.msalService.instance.getAllAccounts();
                    if (accounts.length > 0) {
                        //this.msalService.instance.setActiveAccount(accounts[0]);
                        this.userService.socialSignIn(accounts[0].idToken)
                    }
                }else if (msalSubject.eventType === 'msal:logoutSuccess') {
                    this.functionService.executeFunction(FUNCTION.LOGOUT)
                }
            }
        })

        // google auth state change
        this.authService.authState.pipe(takeUntil(this.destroy$)).subscribe(async (socialUser:SocialUser) => {
            if (socialUser) {
                this.userService.socialSignIn(socialUser.idToken)
            }else {
                this.functionService.executeFunction(FUNCTION.LOGOUT)
            }
        });

        /*if (environment.tracking) {
            this.router.events.pipe(takeUntil(this.destroy$)).subscribe((y: NavigationEnd) => {
                if (y instanceof NavigationEnd){
                    if (y.url.startsWith("/register") || y.url.startsWith("/registered")) {
                        const scriptTag = document.createElement("script");
                        scriptTag.innerHTML = `
                            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                            })(window,document,'script','dataLayer','${environment.googleTagManagerID}');
                        `;
                        document.head.appendChild(scriptTag);
                        const noscriptTag = document.createElement("noscript");
                        noscriptTag.innerHTML = `
                            <iframe src="https://www.googletagmanager.com/ns.html?id=${environment.googleTagManagerID}"
                            height="0" width="0" style="display:none;visibility:hidden"></iframe>
                        `;
                        document.body.insertBefore(noscriptTag, document.body.firstChild);
                    }
                }
            })
        }*/

        this.breakpointObserver.observe([Breakpoints.Small, Breakpoints.XSmall, Breakpoints.Medium, Breakpoints.Large])
            .pipe(takeUntil(this.destroy$))
            .subscribe(result => {
                this.smallScreen = result.breakpoints[Breakpoints.Small] || result.breakpoints[Breakpoints.XSmall]
                this.mediumScreen = result.breakpoints[Breakpoints.Medium]
                this.largeScreen = result.breakpoints[Breakpoints.Large]

                this.onboardingWidth = this.smallScreen?410:700
                this.cdRef.detectChanges()
        });
    }
    
    ngOnDestroy(): void {
        this._destroying$.next(undefined);
        this._destroying$.complete();
    }
       
    isWithinApplication() {
        return this.router.url !== "/auth" && this.router.url !== "/register"
    }

    helpColor() {
        return AppComponent.help?'warn':'accent'
    }

    helpButtonClick () {
        AppComponent.help = !AppComponent.help
    }  
    
}
